// Slot'un gösterilecek/etkin fiyatını hesaplar (kuruş cinsinden).
//
// Üç fiyatlandırma modu vardır:
//   Özel     (priceOverride = 1)                    -> kullanıcının elle girdiği slotPrice kullanılır.
//   Otomatta (priceOverride = 0, slotPrice <= 0)    -> fiyat 0; gerçek fiyat otomat üzerinde
//                                                       belirlenir. DB'ye 0 yazılır.
//   Standart (priceOverride = 0, slotPrice >= 0)    -> stoğun liste fiyatı kullanılır. Kayıt sırasında
//                                                       stoğun O ANKİ fiyatı slotPrice'a yazılır
//                                                       (snapshot) — otomata 0 gitmesin diye.
//                                                       Bkz. getSlotPriceToSave.
//
// stockPriceMap: { [stockId]: stockPrice } — stok kartlarından türetilen güncel fiyat haritası.

// "Otomatta" modunun form içindeki işareti. DB'ye 0 olarak yazılır
// (bkz. getSlotPriceToSave); formda 0 ile "standart"tan ayrışması için negatif.
export const OTOMATTA_SLOT_PRICE = -1;

// Slot'un fiyat tipini döndürür: "ozel" | "otomatta" | "standart".
// Standart slotlar artık gerçek fiyatla kaydedildiği için slotPrice <= 0 "otomatta" demektir.
export function getSlotPriceType(row) {
  if (Number(row?.priceOverride) === 1) return "ozel";
  if (Number(row?.slotPrice) <= 0) return "otomatta";
  return "standart";
}

// API'ye yazılacak slotPrice'ı hesaplar — tek kural, iki giriş noktası.
// Tüm kayıt yolları (form, sürükle-bırak, JSON yükle, otomatlara ata) bunu kullanmalı
// ki "standart" slotlar otomata 0 gitmesin.
export function getSlotPriceToSaveByType(priceType, enteredPrice, stockPrice) {
  if (priceType === "ozel") return Number(enteredPrice) || 0;
  if (priceType === "otomatta") return 0;
  return Number(stockPrice) || 0; // standart: stoğun o anki liste fiyatı
}

// DB/local satır şeklindeki kayıtlar için (tipi satırdan çıkarır).
export function getSlotPriceToSave(row, stockPrice) {
  return getSlotPriceToSaveByType(getSlotPriceType(row), row?.slotPrice, stockPrice);
}

export function getEffectiveSlotPrice(row, stockPriceMap) {
  // Özel: elle girilen fiyat.
  if (Number(row?.priceOverride) === 1) {
    return Number(row?.slotPrice) || 0;
  }
  // Otomatta: fiyat 0.
  if (Number(row?.slotPrice) <= 0) {
    return 0;
  }
  // Standart: stoğun güncel liste fiyatı (dinamik).
  const stockPrice = stockPriceMap?.[row?.stockId];
  return stockPrice != null ? Number(stockPrice) : 0;
}
